import { render, staticRenderFns } from "./LGATickets.vue?vue&type=template&id=4f4c385e&"
import script from "./LGATickets.vue?vue&type=script&lang=js&"
export * from "./LGATickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports